import {
  Card,
  CardContent,
  Grid,
  Switch,
  TextField,
  Typography,
  FormControlLabel,
  Box,
} from "@mui/material";
import React, { useState } from "react";

const Preferences = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [xirrChecked, setXirrChecked] = useState(true);
  const [navChecked, setNavChecked] = useState(true);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  const handleXirrChange = (event) => {
    setXirrChecked(event.target.checked);
  };

  const handleNavChange = (event) => {
    setNavChecked(event.target.checked);
  };

  const filteredPreferences = [
    { name: "XIRR", checked: xirrChecked, handleChange: handleXirrChange },
    { name: "NAV", checked: navChecked, handleChange: handleNavChange },
    { name: "Ledger Balance", checked: false, handleChange: null },
    { name: "Net Contribution", checked: false, handleChange: null },
  ].filter((preference) => preference.name.toLowerCase().includes(searchQuery));

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card
          sx={{
            padding: 2,
            boxShadow: 0.1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Advisor Name: Vishnu Jariwala</Typography>
          <TextField
            size="small"
            placeholder="Search"
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </Card>
      </Grid>
      {filteredPreferences.map((preference, index) => (
        <Grid item xs={12} key={index}>
          <Card
            sx={{
              padding: 1,
              boxShadow: 2,
            }}
          >
            <CardContent>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6}>
                  <Typography variant="h6">{preference.name}</Typography>
                </Grid>
                {preference.handleChange && (
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        width: "100%",
                      }}
                    >
                      <Typography sx={{ marginRight: 2 }}>With Cash</Typography>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={preference.checked}
                            onChange={preference.handleChange}
                          />
                        }
                        label="Without Cash"
                        labelPlacement="end"
                      />
                    </Box>
                  </Grid>
                )}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default Preferences;
